import ImportDialog from './Index.vue'

ImportDialog.install = function(Vue) {
  Vue.component(ImportDialog.name, ImportDialog)
}

export default ImportDialog
